import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import CardAccordion from 'components/Customs/Accordion/CardAccordion';
import DetailFeature from 'components/CarFile/Information/DetailFeature';

const FeaturesSalfa = (car) => {
  const [activeKey, setActiveKey] = useState('0');

  // Generar listado general de características
  const listFeatures = [
    { title: 'Kilómetros', value: car.kms },
    { 
      title: 'Precio', 
      value: car.moneda + new Intl.NumberFormat('es-CL').format(car.precio)
    },
    { title: 'Transmisión', value: car.transmisionNombre },
    { title: 'Combustible', value: car.combustibleNombre },
    { title: 'Año', value: car.year },
    { title: 'Color', value: car.color },
    { title: 'Puertas', value: car.puertas },
    // Agrega más campos según necesites...
  ];

  // Transformar el objeto "caracteristicas" en un array legible
  const listSpecific = Object.entries(car.caracteristicas || {}).map(
    ([key, val]) => ({
      title: key,
      value: val === 'S' ? 'Sí' : val === 'N' ? 'No' : val,
    })
  );

  const sections = [
    { id: 1, title: 'Detalle del vehículo', listado: listFeatures, isVisibleSubtitle: true },
    { id: 2, title: 'Características específicas', listado: listSpecific, isVisibleSubtitle: false },
  ];

  return (
    <div className="accordion-car__row">
      <div className="accordion-car">
        <Accordion activeKey={activeKey} onSelect={setActiveKey}>
          {sections.map((sec, i) => (
            <CardAccordion
              title={sec.title}
              key={sec.id}
              index={i}
              activeKey={activeKey}
            >
              <div className="details-car">
                {sec.listado.length > 0 ? (
                  sec.listado.map((item, idx) => (
                    <DetailFeature
                      key={idx}
                      title={item.title}
                      value={item.value}
                      isVisibleSubtitle={sec.isVisibleSubtitle}
                    />
                  ))
                ) : (
                  <p>No hay información disponible</p>
                )}
              </div>
            </CardAccordion>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default FeaturesSalfa;
